import styled from '@emotion/styled';
import { css } from '@emotion/react';

const ModalGalleryContainer = styled('div')(
    ({ theme }) => css`
        position: relative;
        width: 100%;
        margin: ${theme.spacing['16px']} auto;
    `
);

const FloorPlanExternalList = styled('ul')(
    ({ theme }) => css`
        width: 100%;
        margin: ${theme.spacing['16px']};
        padding: 0;
        list-style: none;

        ${theme.mq.medium} {
            width: 40%;
            margin: 0 auto;
            align-self: center;
        }
    `
);

const FloorPlanExternalItem = styled('li')(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['16px']};
    `
);

export { ModalGalleryContainer, FloorPlanExternalList, FloorPlanExternalItem };
